module.exports = __webpack_public_path__ + "img/gc_country_flag_bg.0a427a9f.svg";